import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    position: "relative",
    padding: theme.spacing(3),
    minWidth: 720,
    background: theme.palette.background.paper,
    boxShadow:
      "0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)",

    height: "100%",
    "& label": {
      minWidth: "auto !important",
      maxWidth: "280px !important",
      width: "max-content !important",
    },
    "& .text-field-wrapper > div": {
      width: "470px !important",
      marginLeft: "auto",
    },

    "&::after": {
      left: "-16px",
      width: "20px",
      bottom: "0px",
      top: "0",
      content: '""',
      position: "absolute",
      backgroundColor: "transparent",
      backdropFilter: "blur(3px)",
    },
    [theme.breakpoints.down("960")]: {
      width: "100%",
      minWidth: "unset",

      "&::after": {
        display: "none",
      },
    },
  },
  headingContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  menuHeading: {
    fontWeight: 600,
    fontSize: "30px",
    lineHeight: "38px",
    color: theme.palette.text.primary,
  },
  subtitle: {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "38px",
    color: theme.palette.text.tertiary,
  },
  detailsContainer: {
    position: "relative",
  },
  detailsBg: {
    background: theme.palette.utility.brand_200,
    height: "68px",
    marginBottom: "57px",
  },
  detailsContent: {
    padding: "0px 32px",
    position: "absolute",
    top: "20px",
    width: "100%",
    [theme.breakpoints.down(321)]: {
      padding: "0px 12px",
    },
  },
  inputwrapper: {
    "& label": {
      minWidth: "auto !important",
      maxWidth: "280px !important",
      width: "max-content !important",
    },
    gap: "0",
    width: "100% !important",
    [theme.breakpoints.down("605")]: {
      gap: "6px",
    },
  },
  divider: {
    margin: "16px 0",
  },
  titleDivider: {
    marginTop: "20px",
    marginBottom: "32px",
  },
  fieldWrapper: {
    width: "100% !important",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "12px",
    marginTop: "57px",
  },
  sectionHeader: {
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "28px",
    color: theme.palette.text.primary,
  },
  addInvoiceContainer: {
    display: "flex",
    gap: "32px",
    alignItems: "center",
  },
  addInvoiceButton: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
  },
  numberOfInvoicesTitle: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.text.secondary,
  },
  addInvoiceText: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.button.tertiaryColor_fg,
  },
  numberOfInvoicesAdded: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.text.tertiary,
  },
  viewNumberOfInvoicesTitle: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.text.brand_700,
  },
  invoicesSubText: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.text.tertiary,
  },
  addInvoicesContainer: {
    background: theme.palette.background.gray_50,
    borderRadius: 8,
    padding: 16,
    marginTop: 16,
  },
}));
